<script>
  import microphoneImage from '../assets/microphone.svg?inline'
  import QrCode from './qrcode.mjs';
	import { fade } from 'svelte/transition';

  let {
    textTitle,
    textSubtitle = null,

    collectionId = null,
    paperId = null,
    songId = null,
    lyricId = null,

    paperTitle,
    paperAuthors,
    songTitle,
    songArtist,

    notes = null,

    textContinue = null,
    textButtonBack = null,
    textButtonAction = null,
    buttonBack = null, // event
    buttonAction = null, // event
    buttonContinue = null, // event
    buttonPasskeyClick = null, // event

    showQRCode = false,
  } = $props();
  
  let qrUrl = $state(null);
  let qrSrc = $state(null);
  
  function handleButtonBack() {
    if (buttonBack) {
      buttonBack();
    }
  }

  function handleButtonAction() {
    if (buttonAction) {
      buttonAction();
    }
  }

  function handleButtonContinue() {
    if (buttonContinue) {
      buttonContinue();
    }
  }

  $effect(() => {
    if (showQRCode && !lyricId) {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      if (collectionId) {
        params.set('collectionId', collectionId);
      }
      if (paperId) {
        params.set('paperId', paperId);
      }
      if (songId) {
        params.set('songId', songId);
      }
      qrUrl = url.href;
      const options = {
        color: 'white',
        moduleRound: 1.0,
        finderRound: 0.5,
      };
      const matrix = QrCode.generate(qrUrl);
      const uri = QrCode.render('svg-uri', matrix, options);
      qrSrc = uri;
    } else {
      qrUrl = '';
      // spell-checker:disable-next-line
      //qrSrc = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg"/%3E';
      qrSrc = '';
    }
  });
</script>


<div class="container">

  <div class="button-container back">
    {#if textButtonBack}
      <button class="button back" onclick={() => { handleButtonBack(); }}>
        {textButtonBack}
      </button>
    {:else}
      <!-- Placeholder -->
      <!-- svelte-ignore a11y_consider_explicit_label -->
      <button class="button back" disabled style="visibility: hidden;">&nbsp;</button>
    {/if}
  </div>

  <div class="header">
    <div class="title">
      <!-- svelte-ignore a11y_no_static_element_interactions -->
      <!-- svelte-ignore a11y_click_events_have_key_events -->
      <svg class="logo" version="1.1" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" onclick={() => { if (buttonPasskeyClick) buttonPasskeyClick() }}>
        <path fill="currentColor" d="m256 320a78.83 78.83 0 0 1-56.55-24.1 80.89 80.89 0 0 1-23.45-56.9v-111a79.69 79.69 0 0 1 80-80c44.86 0 80 35.14 80 80v111c0 44.66-35.89 81-80 81zm-128-128a16 16 0 0 0-16 16v32c0 73.715 56.322 135 128 143.04v48.955h-48a16 16 0 0 0-16 16 16 16 0 0 0 16 16h128a16 16 0 0 0 16-16 16 16 0 0 0-16-16h-48v-48.955c71.678-8.0463 128-69.33 128-143.04v-32a16 16 0 0 0-16-16 16 16 0 0 0-16 16v32c0 61.673-50.327 112-112 112s-112-50.327-112-112v-32a16 16 0 0 0-16-16z"/>
      </svg>
      {textTitle}
    </div>
    {#if textSubtitle}
      <div class="subtitle">{textSubtitle}</div>
    {/if}
  </div>

  {#if textButtonAction}
  <div class="button-container major">
      <button class="button" onclick={() => { handleButtonAction(); }}>
        {textButtonAction}
      </button>
    </div>
  {/if}




  <div class="paper-wrapper">

    <!-- <div class="divider">Paper</div> -->

    <div class="papers-grid">
      <div class="paper-card">
        <div class="paper-title">{paperTitle}</div>
        <div class="paper-author">{paperAuthors}</div>
        <div class="paper-description">🎵 {songArtist} — {songTitle}</div>
      </div>
    </div>

    {#if qrSrc}
      <div transition:fade class="qr-code">
        <img id="qr-img" src={qrSrc} title={qrUrl} alt="QR Code" />
      </div>
    {/if}

    {#if notes}
      <div class="notes">
        {notes}
      </div>
    {/if}

  </div>


  {#if textContinue}
    <div class="continue-btn-container">
      <button
        class="continue-btn"
        onclick={handleButtonContinue}
      >
        {textContinue}
      </button>
    </div>
  {/if}


</div>
<style>
.qr-code {
  text-align: center;
}
#qr-img {
  width: min(90vw, 20em);
}
.container {
  height: 100vh;
  height: 100dvh;
  max-height: 100vh;
  max-height: 100dvh;
  background: linear-gradient(135deg, #742bb0 0%, #4b6cb7 100%);
  color: white;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.header {
  text-align: center;
  /* // margin-bottom: 2em; */
  padding: 1em;
  padding-top: 0;
  background: rgba(0, 0, 0, 0.8);
}
.logo {
  display: inline-block;
  width: min(10vmin, 1em);
  position: relative;
  top: 5px;
}
.title {
  font-size: min(8vmin, 2.5em);
  font-weight: bold;
  margin-bottom: 0.25em;
}
.subtitle {
  margin-top: 0.25em;
  font-size: min(4vmin, 1.25em);
  opacity: 0.8;
}

.button-container {
  margin: 0 auto 2em auto;
  width: 100%;
  position: relative;
}
.button-container.back {
  display: block;
  width: 100vw;
  text-align: left;
  margin: 0;
  background: rgba(0, 0, 0, 0.8);
}
.button, button {
  width: auto;
  text-align: left;
  padding: 1em 1.5em 1em 1.5em;
  border-radius: 50px;
  border: none;
  background: transparent;
  color: white;
  font-size: 1.1em;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}
.button.back {
  font-size: 1em;
  padding: 0.5em;
  min-width: auto;
  opacity: 0.7;
}
.button-container.major {
    text-align: center;
    margin: auto;
    background: rgba(0, 0, 0, 0.8);
    padding-bottom: 0.75em;
    display: block;
    text-align: center;
}
.button-container.major button {
    background: linear-gradient(135deg, #742bb0 0%, #4b6cb7 100%);
    display: inline-block;
}




.paper-wrapper {
  flex: 1;
  overflow-y: auto;
  padding: min(2vw, 2em);
  padding-top: 0;
  background: rgba(0, 0, 0, 0.8);
}
.papers-grid {
  display: flex;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5em;
  padding: 1em;

  /* // max-height: calc(100vh - 300px); */
  flex-direction: column;
  max-width: 1200px;
  margin: 0 auto;
}
.paper-card {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 4vmin;
  font-size: min(3vmin, 1.25em);
  /*cursor: pointer;*/
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  border: 2px solid transparent;
}
/*
.paper-card:hover {
  transform: translateX(10px);
  background: rgba(255, 255, 255, 0.15);
}
.paper-card.selected, .paper-card:active {
  border-color: #00ffff;
  background: rgba(76, 142, 175, 0.1);
}
*/
.paper-title {
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 0.5em;
}
.paper-author {
  font-size: 0.9em;
  opacity: 0.8;
}
.paper-description {
  margin-top: 0.8em;
  margin-bottom: 0;
  font-size: 0.9em;
  opacity: 0.8;
  display: inline-block;
  padding: 0.5em 1.2em;
  border-radius: 20px;
  color: #000;
  background: #ccc;
}





.continue-btn-container {
  text-align: center;
  padding: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.2);
}
.continue-btn, button {
  background: #fff;
  color: #4527a0;
  border: none;
  padding: 1em 2em;
  border-radius: 50px;
  font-size: 1.1em;
  cursor: pointer;
  transition: all 0.3s ease;
  display: block;
  min-width: 200px;
}
.continue-btn:disabled {
  background: #bdbdbd;
  color: #777;
  cursor: not-allowed;
}
.continue-btn:not(:disabled):hover, button:hover {
  /* // transform: scale(1.05); */
  /* // box-shadow: 0 0 20px rgba(76, 175, 80, 0.3); */
  transform: scale(1.05);
  box-shadow: 0 0 15px #2196f3;
}
/*
.divider {
  margin-top: 0.6em;
  margin-bottom: 0.3em;
  text-transform: uppercase;
  opacity: 0.7;
}
*/
.notes {
  border-radius: 15px;
  border: 1px solid white;
  padding: 1em;
  display: block;
  font-size: large;
  opacity: 0.7;
  text-align: center;
  max-width: 600px;
  margin: auto;
  margin-top: 1em;
}
</style>